import * as React from 'react';
import { MapTooltipContainer } from './styled';

export interface MapTooltipProps {
  title: string;
  metric: string;
  value: React.ReactNode;
}

const MapTooltip = ({ title, metric, value }: MapTooltipProps) => (
  <MapTooltipContainer>
    <div className="title">{title}</div>
    <div className="content">
      <span className="label">{metric}</span>
      <span className="value">{value}</span>
    </div>
  </MapTooltipContainer>
);

export default React.memo(MapTooltip);
